import React, { createContext, useState, useContext, useRef } from 'react';

// Criação do Contexto
const UploadProgressContext = createContext();

// Hook customizado para facilitar o uso
export const useUploadProgress = () => useContext(UploadProgressContext);

export const UploadProgressProvider = ({ children }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [progress, setProgress] = useState(0);
  const [statusMessage, setStatusMessage] = useState('');
  const [statusState, setStatusState] = useState(''); // 'INICIADO', 'PROCESSANDO', 'SUCESSO', 'ERRO'
  const wsRef = useRef(null);

  // Função para abrir o WebSocket e iniciar o acompanhamento
  const startTracking = (jobId) => {
    setIsProcessing(true);
    setProgress(0);
    setStatusMessage('Enviando arquivo para a nuvem...');
    setStatusState('INICIADO');

    // Substitua pela URL da sua API WebSocket gerada no API Gateway
    const wsUrl = process.env.REACT_APP_WEBSOCKET_URL || 'wss://ydihvfp4rg.execute-api.us-east-1.amazonaws.com/V01';
    
    wsRef.current = new WebSocket(wsUrl);

    // EVENTO: Quando a conexão é aberta
    wsRef.current.onopen = () => {
      console.log('WebSocket aberto. Registrando jobId:', jobId);
      // Envia uma mensagem inicial para sua Lambda "$connect" ou "registrar" associar este ID de conexão ao jobId
      wsRef.current.send(JSON.stringify({
        action: 'registrarJob',
        jobId: jobId
      }));
    };

    // EVENTO: O LISTENER que recebe as mensagens do Lambda
    wsRef.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('Mensagem da Lambda:', data);
      
      if (data.progresso !== undefined) setProgress(data.progresso);
      if (data.mensagem) setStatusMessage(data.mensagem);
      if (data.status) setStatusState(data.status);

      // Regra de finalização: Aguarda 5 segundos mostrando sucesso/erro e fecha tudo
      if (data.status === 'SUCESSO' || data.status === 'ERRO') {
        setTimeout(() => {
          setIsProcessing(false);
          if (wsRef.current) wsRef.current.close();
        }, 5000);
      }
    };

    // EVENTO: Em caso de erro na conexão
    wsRef.current.onerror = (error) => {
      console.error('Erro WebSocket:', error);
      setStatusState('ERRO');
      setStatusMessage('Falha na conexão em tempo real.');
    };
  };

  return (
    <UploadProgressContext.Provider 
      value={{ isProcessing, progress, statusMessage, statusState, startTracking }}
    >
      {children}
    </UploadProgressContext.Provider>
  );
};
